export class RequestValidationParameters
{
    accept: boolean;
    rating?: number;
    description: string;
}
